/**
 *
 * HeaderTitle
 *
 */

import HeaderTitle from './HeaderTitle.jsx';
import './HeaderTitle.less';

export default HeaderTitle; 
